export const AdvertisementHalfFields = `
{
    text
    advertisement
}
`;
